export class TokenGestaoPerfilModel {
    constructor(public Id: string = "", public Nome: string = "") {}
  }
  